import React, { useState } from 'react'

import FormBlock from 'components/Forms/FormBlock'
import FormModal from 'components/Modal/FormModal/FormModal'
import Toast, { TOAST_TYPE } from 'components/Toast/Toast'
import Input from 'components/Forms/Input/Input'
import Select from 'components/Forms/Select/Select'

import { fieldsValidator, getIsNotEmptyStringRule, getIsNotIncludeInArray, getIsValueRule } from 'utils/fieldsValidator'
import { removeKeyFromObject } from 'utils/common'

import { getCurrencyOption } from './utils'

const EditCountryCurrencyModal = ({ currencies, otherCountryCodes, payload, onSubmit, onClose }) => {
    const [currency, setCurrency] = useState(() => {
        const oldCurrency = currencies.find(item => item.currency === payload.currency)
        if (!oldCurrency) return null
        return getCurrencyOption(oldCurrency)
    })
    const [countryCode, setCountryCode] = useState(payload.countryCode)

    const [errors, setErrors] = useState({})

    const handleSubmit = async () => {
        try {
            setErrors({})

            const validator = new fieldsValidator()

            validator.addFields([
                validator.createField('countryCode', countryCode, [
                    getIsValueRule(),
                    getIsNotEmptyStringRule(),
                    getIsNotIncludeInArray(otherCountryCodes, `Country code "${countryCode}" already exist`),
                ]),
                validator.createField('currency', currency, [getIsValueRule()]),
            ])

            const { isHasErrors, errors } = validator.validate()
            if (isHasErrors) {
                setErrors(errors)
                return
            }

            await onSubmit({ ...payload, countryCode, currency: currency.value })

            return true
        } catch (err) {
            console.error(err)
            Toast(TOAST_TYPE.ERROR)
            throw err
        }
    }

    return (
        <FormModal
            headText="Update country currency"
            successText="Country currency update successfully!"
            actionText="Update"
            onAction={() => handleSubmit()}
            onClose={() => onClose()}
        >
            <FormBlock label="Country code">
                <Input
                    value={countryCode}
                    error={errors.countryCode}
                    onChange={value => {
                        setCountryCode(value)
                        setErrors(removeKeyFromObject(errors, 'countryCode'))
                    }}
                />
            </FormBlock>
            <FormBlock label="Currency">
                <Select
                    value={currency}
                    error={errors.currency}
                    options={currencies.map(item => getCurrencyOption(item))}
                    onChange={value => {
                        setCurrency(value)
                        setErrors(removeKeyFromObject(errors, 'currency'))
                    }}
                />
            </FormBlock>
        </FormModal>
    )
}

export default EditCountryCurrencyModal
